import React, { useState, useEffect } from "react";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import {
  AdminPageTitle,
  AdminMainText,
  AdminSupportingText,
  AdminDetailFieldLabel,
  AdminHeaderAction,
  adminWizardInputClasses,
  adminPaymentInputClasses,
} from "../../sections/AdminDashboard/shared/adminUx";

const UpdateCardPopup = ({ isOpen, onClose }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    cardNumber: "",
    expiryDate: "",
    cvc: "",
    cardholderName: "",
  });

  useEffect(() => {
    if (isOpen) {
      setCurrentStep(1);
      setFormData({
        cardNumber: "",
        expiryDate: "",
        cvc: "",
        cardholderName: "",
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (currentStep === 2) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [currentStep, onClose]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveCard = () => {
    setCurrentStep(2);
  };

  const formatCardNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    return digits.replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  const formatExpiryDate = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length >= 2) {
      return `${digits.slice(0, 2)} / ${digits.slice(2, 4)}`;
    }
    return digits;
  };

  if (!isOpen) return null;

  const inputClass = adminWizardInputClasses(false);

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            {currentStep === 1 ? (
              <form onSubmit={(e) => e.preventDefault()}>
                <AdminPageTitle className="text-center pb-0 text-offblack mb-6">
                  Update card
                </AdminPageTitle>

                <div className="space-y-4">
                  <div className="space-y-1 w-full min-w-0">
                    <AdminDetailFieldLabel htmlFor="cardholderName">Cardholder name</AdminDetailFieldLabel>
                    <input
                      id="cardholderName"
                      type="text"
                      placeholder="John Smith"
                      value={formData.cardholderName}
                      onChange={(e) => handleInputChange("cardholderName", e.target.value)}
                      className={inputClass}
                    />
                  </div>

                  <div className="space-y-1 w-full min-w-0">
                    <AdminDetailFieldLabel htmlFor="cardNumber">Card number</AdminDetailFieldLabel>
                    <input
                      id="cardNumber"
                      type="text"
                      placeholder="1234 5678 9012 3456"
                      value={formData.cardNumber}
                      onChange={(e) =>
                        handleInputChange("cardNumber", formatCardNumber(e.target.value))
                      }
                      className={inputClass}
                      maxLength={19}
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-2 space-y-1 w-full min-w-0">
                      <AdminDetailFieldLabel htmlFor="expiryDate">Expiry date</AdminDetailFieldLabel>
                      <input
                        id="expiryDate"
                        type="text"
                        placeholder="MM / YY"
                        value={formData.expiryDate}
                        onChange={(e) =>
                          handleInputChange("expiryDate", formatExpiryDate(e.target.value))
                        }
                        className={`${adminPaymentInputClasses(false, false, "120")} !block !w-full !max-w-full`}
                        maxLength={7}
                      />
                    </div>
                    <div className="space-y-1 w-full min-w-0">
                      <AdminDetailFieldLabel htmlFor="cvc">CVC</AdminDetailFieldLabel>
                      <input
                        id="cvc"
                        type="text"
                        placeholder="123"
                        value={formData.cvc}
                        onChange={(e) =>
                          handleInputChange("cvc", e.target.value.replace(/\D/g, ""))
                        }
                        className={`${adminPaymentInputClasses(false, false, "96")} !block !w-full !max-w-full`}
                        maxLength={4}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-end mt-4 w-full">
                  <AdminHeaderAction type="button" onClick={handleSaveCard}>
                    Save
                  </AdminHeaderAction>
                </div>
              </form>
            ) : (
              <div className="text-center">
                <div className="w-16 h-16 bg-freshgreen rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <AdminPageTitle className="text-center pb-0 text-offblack mb-2">
                  Card updated
                </AdminPageTitle>
                <AdminSupportingText className="text-mediumgray block">
                  Your payment method has been updated.
                </AdminSupportingText>
              </div>
            )}
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default UpdateCardPopup;
